import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const RefundPolicy = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      
      <main className="flex-grow">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <h1 className="text-3xl font-bold mb-8">Refund Policy</h1>
          
          <div className="prose max-w-none">
            <p className="mb-8">
              Subject to these terms, we do not offer refunds on the provision of services.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RefundPolicy; 